import React, { useState } from "react";
import clsx from "clsx";

import AppSwitch from "@/components/AppSwitch";
import AppBox from "@/components/AppBox";
import AppInput from "@/components/AppInput";
import AppIcon from "@/components/AppIcon";

interface AppSwitchInputProps {
  label: string;
  inputPlaceholder: string;
  checked: boolean;
  showInput: boolean;
  labelPosition: 'left' | 'right';
  onChange: (value?: string) => void;
}

const AppSwitchInput: React.FC<AppSwitchInputProps> = ({
  label,
  inputPlaceholder,
  checked,
  showInput,
  labelPosition = 'right',
  onChange,
}) => {
  const [isInputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState<string | null>(null);

  // Handle toggle for switch
  const handleSwitchToggle = () => {
    if (!showInput) {
      onChange();
      return;
    }
    setInputVisible((prev) => !prev);
  };

  // Handle input confirmation and reset
  const handleIconClick = (isConfirm: boolean) => {
    if (isConfirm) {
      if (inputValue.trim()) {
        onChange(inputValue);
      } else {
        setError("Please enter a phone number");
        return;
      }
    }
    setError(null);
    setInputValue("");
    setInputVisible(false);
  };

  return (
    <AppBox align="center" className="relative h-[38px]">
      {/* AppSwitch - visible when input is hidden */}
      {!showInput || !isInputVisible ? (
        <AppBox className="absolute transition-opacity duration-300">
          <AppSwitch label={label} checked={!!checked} labelPosition={labelPosition} onChange={handleSwitchToggle} />
        </AppBox>
      ) : null}

      {/* Input and Action Buttons - visible when input is active */}
      {showInput && isInputVisible ? (
        <AppBox className="absolute flex items-center gap-2 transition-opacity duration-300">
          <AppInput
            value={inputValue}
            onChange={(value: string) => setInputValue(value)}
            placeholder={inputPlaceholder}
            autoFocus
            error={error}
          />
          {/* Confirm Icon */}
          <button
            className="text-primary hover:text-green-700"
            onClick={() => handleIconClick(true)}
          >
            <AppIcon name="check" />
          </button>
          {/* Cancel Icon */}
          <button
            className="text-error hover:text-error-hover"
            onClick={() => handleIconClick(false)}
          >
            <AppIcon name="x" />
          </button>
        </AppBox>
      ) : null}
    </AppBox>
  );
};

export default AppSwitchInput;